import { apiClient, ApiClient } from "@/lib/api/api-client";
import {
  ContributeFeatureInfo,
  RegistWishlistInfo,
} from "../types/contactsupport/contactsupport";
import { BaseResponse } from "../types/response";

export class ContactSupportService {
  private BASE_PATH =
    process.env.API_CONTACTSUPPORT_ENDPOINT ||
    "http://localhost:8081/support-contact";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async registWishlist(infor: RegistWishlistInfo): Promise<BaseResponse> {
    return this.apiClient.fetch<BaseResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/wishlist`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(infor),
      },
    );
  }

  async contributeFeature(data: ContributeFeatureInfo): Promise<BaseResponse> {
    return this.apiClient.fetch<BaseResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/contribute/features`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
      },
    );
  }
}

export const contactSupportService = new ContactSupportService();
